export default __webpack_public_path__ + "static/media/align_horizontal_left.f2caf0f7.svg";